import React from 'react';
import PropTypes from 'prop-types';

import { ComponentPreview, ComponentTooltip } from './raketa-ui/page-builder/ComponentPreview';
import { SideNav, NavItem, NavButton, NavPanel, NavSectionTitle, NavSectionMenuItem, SideNavSpacer, SideNavSearchWrapper } from './raketa-ui/components/SideNav';

import { FaRocket, FaSearch } from 'react-icons/fa';
import { MdViewQuilt, MdRemoveRedEye, MdDone, MdExitToApp, MdFormatLineSpacing, MdSettings } from 'react-icons/md';

import TextInput from './forms/TextInput';

import { WIDGET_LIST } from '../widgets';

const Tooltip = ({ topPosition, tootipWidgetImageClass, tooltipClass }) => (
  <ComponentTooltip className={`tooltip-img ${tooltipClass} ${tootipWidgetImageClass}`} style={{ top: `${topPosition}px` }} />
);

const sidebarWidget = (widgetIdx, widgetName, onAddWidget, onMouseIn, onMouseOut) => (
  <ComponentPreview
    key={widgetIdx}
    onClick={(e) => { e.preventDefault(); onAddWidget(widgetName); }}
    onMouseEnter={e => onMouseIn(e.target.offsetTop, WIDGET_LIST[widgetName].name)}
    onMouseLeave={e => onMouseOut(e.target.offsetTop)}
  >
    {WIDGET_LIST[widgetName].title}
  </ComponentPreview>
);


const fileteredWidgets = (widgets, search = '') => {
  if (search === '') return widgets;

  const filteredNames = Object.keys(widgets).filter(widgetName =>
    WIDGET_LIST[widgetName].title.toLowerCase().indexOf(search.toLowerCase()) !== -1);

  const filteredWidgets = {};

  filteredNames.forEach((widgetName) => {
    filteredWidgets[widgetName] = WIDGET_LIST[widgetName];
  });

  return filteredWidgets;
};

const filteredCategoryName = (categoryName, fileteredWidgetNames, search = '') => {
  if (search === '') return true;

  const filteredWidgets = [];

  Object.keys(WIDGET_LIST).forEach((widget) => {
    fileteredWidgetNames.forEach((widgetName) => {
      if (widgetName === WIDGET_LIST[widget].name) filteredWidgets.push(WIDGET_LIST[widget]);
    });
  });

  let showCategory = false;

  filteredWidgets.forEach((widget) => {
    if (widget.category === categoryName) showCategory = true;
  });

  return showCategory;
};

class AdminSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      widgetName: '',
      search: '',
      tooltipTopPosition: 0,
      tootipWidgetImageClass: '',
    };
  }

  componentDidMount() {
    const widgetsBar = document.querySelector('.widgets-list-bar');
    const widgetButtonsList = [...document.querySelectorAll('.widgets-list-bar button')];

    widgetsBar.addEventListener('scroll', () => {
      widgetButtonsList.forEach((button) => {
        button.addEventListener('mouseenter', (e) => {
          this.setState({ tooltipTopPosition: button.getBoundingClientRect().top - 68 });
        })
      });
    });
  }

  handleMouseIn(topPosition, tootipWidgetImageClass) {
    this.setState({ tooltipTopPosition: topPosition - 68, tootipWidgetImageClass });
  }

  handleMouseOut() {
    this.setState({ tooltipTopPosition: 0 });
  }

  renderWidgets(onAddWidget) {
    const widgetsCategories = Object.keys(WIDGET_LIST).map(widgetName =>
      WIDGET_LIST[widgetName].category);
    const widgetsCategoriesFiltered = widgetsCategories.filter((x, i) =>
      widgetsCategories.indexOf(x) === i);

    return (
      <div className="widgets-list">
        <SideNavSearchWrapper>
          <FaSearch style={{
              position: 'relative',
              zIndex: 1,
              fontSize: '20px',
              marginTop: '14px',
              opacity: this.state.search !== '' ? 1 : 0.5 }} />
          <TextInput
            value={this.state.search}
            onChange={e => this.setState({ search: e })}
            placeholder="Search..."
          />
        </SideNavSearchWrapper>

        {widgetsCategoriesFiltered.map((categoryName, idx) =>
          <div key={idx} style={{ marginBottom: '25px' }}>
            {filteredCategoryName(categoryName, Object.keys(fileteredWidgets(WIDGET_LIST, this.state.search)), this.state.search) ? <NavSectionTitle $secondary>{categoryName}</NavSectionTitle> : ''}

            {Object.keys(fileteredWidgets(WIDGET_LIST, this.state.search)).filter(widgetName =>
              WIDGET_LIST[widgetName].category === categoryName).map((widgetName, widgetIdx) =>
                sidebarWidget(
                  widgetIdx, widgetName, name => onAddWidget(name),
                  (topPosition, tootipWidgetImageClass) => this.handleMouseIn(topPosition, tootipWidgetImageClass),
                  () => this.handleMouseOut()
                ),
              )}
          </div>)}
      </div>
    );
  }

  render() {
    const { onSave, onAddWidget, onPreview, isPreview, onWidgetReorderDialogOpen, onPageSettingsOpen } = this.props;

    return (
      <SideNav>
        {/*
          <Tooltip
            topPosition={this.state.tooltipTopPosition}
            widgetName={this.state.tootipWidgetImage}
            tooltipClass={this.state.tooltipTopPosition !== 0 ? 'show-tooltip' : ''}
            tootipWidgetImageClass={this.state.tootipWidgetImageClass}
            />
        */}

        <NavItem>
          <NavButton><FaRocket /></NavButton>
          <NavPanel>
            <NavSectionTitle>Administration</NavSectionTitle>

            <NavSectionMenuItem onClick={() => window.location.href = '/admin/pages'}>Pages</NavSectionMenuItem>
            <NavSectionMenuItem onClick={() => window.location.href = '/admin/articles'}>Articles</NavSectionMenuItem>
            <NavSectionMenuItem onClick={() => window.location.href = '/admin/issues'}>Issues</NavSectionMenuItem>
            <NavSectionMenuItem onClick={() => window.location.href = '/admin/documents'}>Documents</NavSectionMenuItem>
          </NavPanel>
        </NavItem>
        <NavItem>
          <NavButton><MdViewQuilt /></NavButton>
          <NavPanel className="widgets-list-bar">
            <NavSectionTitle>Components</NavSectionTitle>
            {this.renderWidgets(onAddWidget)}
          </NavPanel>
        </NavItem>
        <NavItem>
          <NavButton onClick={onWidgetReorderDialogOpen}><MdFormatLineSpacing /></NavButton>
        </NavItem>
        <NavItem>
          <NavButton onClick={onPageSettingsOpen}><MdSettings /></NavButton>
        </NavItem>
        <NavItem>
          <NavButton $active={isPreview} onClick={onPreview}><MdRemoveRedEye /></NavButton>
        </NavItem>
        <NavItem>
          <NavButton $success onClick={onSave}><MdDone /></NavButton>
        </NavItem>
        <NavItem $bottom>
          <NavButton onClick={() => window.location.href = '/logout'} style={{ borderBottom: 0 }}><MdExitToApp /></NavButton>
        </NavItem>
      </SideNav>
    );
  }
}

AdminSidebar.propTypes = {
  onSave: PropTypes.func.isRequired,
  onAddWidget: PropTypes.func.isRequired,
  onWidgetReorderDialogOpen: PropTypes.func.isRequired,
};

export default AdminSidebar;
